import { Api } from "src/utils/api";
import { AMAZON_URL, AMAZON_URL_V2 } from "../amazonUrl";
import { Product } from "../products/types";

export class AspectsService extends Api {
  constructor() {
    super(AMAZON_URL);
  }

  public async fetchAspectsStats(
    productSource: string,
    productOrId: string | Product,
    offset: number = 0,
    limit: number = 10,
  ): Promise<any> {
    const productId =
      typeof productOrId === "string" ? productOrId : productOrId.asin;

    const response = await this.get(`${AMAZON_URL_V2}/products/aspects/stats`, {
      product_source: productSource,
      product_id: productId,
      offset,
      limit,
    });
    return response;
  }

  public async fetchAspectReviews(
    productSource: string,
    productId: string,
    aspect: string,
    offset: number = 0,
    limit: number = 5,
  ): Promise<any> {
    const response = await this.get(
      `${AMAZON_URL_V2}/products/aspects/reviews`,
      {
        product_source: productSource,
        product_id: productId,
        aspect,
        offset,
        limit,
      },
    );
    return response;
  }

  public async fetchReviewDetails(reviewId: string): Promise<any> {
    const response = await this.get(`${AMAZON_URL}/reviews/details`, {
      review_id: reviewId,
    });
    return response;
  }

  public async fetchProductProblems(
    productSource: string,
    productId: string,
    offset: number = 0,
    limit: number = 5,
  ): Promise<any> {
    const response = await this.get(`${AMAZON_URL_V2}/products/problems`, {
      product_source: productSource,
      product_id: productId,
      offset,
      limit,
    });
    return response;
  }
}
